import { tradingSummary } from '@/utils/tradingSummary';
import CountUp from '@/components/base/CountUp';
import Reveal from '@/components/base/Reveal';

// Headline ledger totals. Every figure is summed straight from `tradeRecords`,
// so adding or editing a trade moves these numbers automatically.
const isProfit = tradingSummary.netProfitValue >= 0;

function NetResultBand() {
  return (
    <section id="net-result" className="w-full px-4 md:px-8 lg:px-12 py-8 md:py-12">
      <div className="max-w-[1440px] mx-auto rounded-lg border border-background-200 bg-background-100 overflow-hidden">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-6 md:px-10 pt-6 md:pt-7">
          <span className="inline-flex items-center gap-2 text-[11px] font-data tracking-[0.22em] text-primary-600">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
            LIVE FROM THE LEDGER
          </span>
          <span className="text-[11px] font-data tracking-[0.18em] text-foreground-400">
            {tradingSummary.instrument} · {tradingSummary.period}
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:divide-x divide-background-200">
          <Reveal>
            <div className="px-6 md:px-10 pt-5 md:pt-6 pb-7 md:pb-9">
              <p className="text-[12px] font-data tracking-[0.2em] text-foreground-500">
                CUMULATIVE NET RESULT
              </p>
              <p
                className={`mt-4 font-data text-[44px] md:text-[56px] font-semibold leading-none ${
                  isProfit ? 'text-profit-600' : 'text-loss-500'
                }`}
              >
                <CountUp
                  value={Math.abs(tradingSummary.netProfitValue)}
                  decimals={2}
                  prefix={isProfit ? '+$' : '-$'}
                />
              </p>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="px-6 md:px-10 pt-5 md:pt-6 pb-7 md:pb-9 border-t md:border-t-0 border-background-200">
              <p className="text-[12px] font-data tracking-[0.2em] text-foreground-500">
                ENDING BALANCE
              </p>
              <p className="mt-4 font-data text-[44px] md:text-[56px] font-semibold leading-none text-foreground-950">
                <CountUp value={tradingSummary.endingBalanceValue} decimals={2} prefix="$" />
              </p>
              <p className="mt-4 text-[13px] text-foreground-500">
                From a starting balance of {tradingSummary.startingBalanceText}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default NetResultBand;